import ImportImages from '@src/importImages';

const ArtBasel = ImportImages('/experiences/Exclusive/art-basel.jpg');
//const Broadway = ImportImages('/experiences/Exclusive/broadway.jpg');
//const BurningMan = ImportImages('/experiences/Exclusive/burnign-man.jpeg');
const GrandPrix = ImportImages('/experiences/Exclusive/grand-prix.jpeg');
//const RedCarpet = ImportImages('/experiences/Exclusive/red-carpet.jpeg');
const Timothy = ImportImages(
  '/experiences/Exclusive/timothy-eberly-515801-unsplash.jpg'
);
//const Pabbles = ImportImages('/experiences/Exclusive/pabbles.jpg');
const Singing = ImportImages('/experiences/Exclusive/singing.jpg');

export default [
  {
    title: 'Safety & Security',
    image: Timothy,
    content:
      '<strong>Trident Response Group</strong>, a Dallas-based elite intelligence and security firm will guide your family' +
      ' through' +
      ' training in Situational Awareness. This will prove to be your most valuable “weapon/defense” as you navigate the world.'
  },
  /*{
    title: 'Film/TV',
    image: RedCarpet,
    content:
      '<strong>John Wick Red Carpet Movie Premiere</strong><br/>May 9, 2019<br/>Walk the red carpet, join' +
      ' celebrities in viewing the movie, then head to the after party.'
  },*/
  {
    title: 'Perform with the Stars',
    image: Singing,
    content:
      'Your Star is Born – How about private singing or dancing lessons with Broadway performer? Or, let’s go to the' +
      ' studio in LA so you can lay down a dynamite track with a famous producer. '
  },
  /*{
    title: 'Awards Shows',
    image: Broadway,
    content:
      '<strong>ESPY Awards: July 10, 2019 / Microsoft Theatre, Los Angeles, CA</strong>' +
      '<br/>The ESPY awards are the academy awards of sports. Spend the evening mingling with your favorite' +
      ' professional athletes and celebrities, with our access to General Admission, VIP Floor Seating, Official After Party and the A-List Pre-Party.'
  },*/
  {
    title: 'Art Festival',
    image: ArtBasel,
    content:
      '<strong>Burning Man: August 25 - September 2, 2019</strong><br/>Black Rock Desert, Nevada<br/>Once a year,' +
      ' tens of thousands of people gather in Nevada’s Black Rock Desert to create Black Rock City, a temporary' +
      ' metropolis dedicated to community, art, self-expression, and self-reliance. Contact us for Admission' +
      ' tickets, Luxury RV rentals and camp placement.<br/><br/><strong>Art Basel Miami: Dec 5 - 8,' +
      ' 2019</strong><br/>Attend the exhibit previews, the hottest events, then party until sun comes at wit a VIP' +
      ' table at LIV or E11EVEN.'
  },
  /*{
    title: 'Art Festival',
    image: BurningMan,
    content:
      '<strong>Burning Man</strong><br/>Aug 25 - Sept 2, 2019<br/>Your luxury RV will be waiting when you' +
      ' land, then enjoy the fun with VIP access. '
  },*/
  {
    title: 'Sports',
    image: GrandPrix,
    content:
      '<strong>Pebble Beach Concours d’Elegance: August 18, 2019</strong><br/>Pebble Beach Golf Links, Pebble Beach,' +
      ' CA<br/>Every August, 200 of the most prized collector cars in the world compete for one of the most' +
      ' prestigious awards in the automotive industry — Best of Show at the Pebble Beach Concours d’Elegance.' +
      ' Enjoy access to General Admission, VIP Lounge and Hospitality passes.<br/><br/><strong>US Open: August 26 -' +
      ' September 8, 2019</strong><br/>USTA Billie Jean King National Tennis Center, New York, NY<br/>The US' +
      ' Open' +
      ' is one of the most special sporting events you can attend in New York City – don’t miss out! Watch today’s' +
      ' biggest names in tennis play at the USTA National Tennis Center from excellent seats, close to the action.' +
      ' Contact us for Premium Seating, Luxury Suites & Hospitality, Player Meet & Greets, and Official After' +
      ' Parties.<br/><br/><strong>US Grand Prix: Nov 1-3, 2019</strong><br/>Austin, Texas<br/>After you visit the pits, head to' +
      ' the Owner’s Club and then join the victory party.<br/><br/><strong>Masters 2020: April 9 - 12th, 2020</strong><br/>August National Golf Club,\' +\n' +
        '      \' Augusta,  GA<br/>Since 1934, the Masters Tournament has been home to some of golf’s greatest moments. Enjoy your\' +\n' +
        '      \' experience at the Masters with access to your own personal chair runner reserving front row seating at\' +\n' +
        '      \' your favorite holes, tournament badges, accommodations, airport transfers, personal driver, and more!'
  }
  /*{
    title: 'Sports',
    image: Pabbles,
    content:
      '<strong>US Open Golf at Pebble Beach</strong><br/>Jun 13–16, 2019<br/>Enjoy VIP access, then meet the pros and hear' +
      ' about' +
      ' their' +
      ' greatest shots.'
  }*/
];



// WEBPACK FOOTER //
// ./src/components/ExclusiveExperience/exclusive-data.js